var selectors = {
  isFetchingMarkdown: function isFetchingMarkdown(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      text = _ref.text;
    return text === null || text === void 0 ? void 0 : text.isFetchingMarkdown;
  },
  markdownFiles: function markdownFiles(_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      text = _ref2.text;
    return text === null || text === void 0 ? void 0 : text.markdownFiles;
  },
  isFetchingJson: function isFetchingJson(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
      text = _ref3.text;
    return text === null || text === void 0 ? void 0 : text.isFetchingJson;
  },
  jsonFiles: function jsonFiles(_temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4,
      text = _ref4.text;
    return text === null || text === void 0 ? void 0 : text.jsonFiles;
  },
  getMarkdownFile: function getMarkdownFile(state, url) {
    var markdownFiles = selectors.markdownFiles(state);
    if (!url) {
      return null;
    }
    return markdownFiles[url];
  },
  getJsonFile: function getJsonFile(state, url) {
    var jsonFiles = selectors.jsonFiles(state);
    if (!url) {
      return null;
    }
    return jsonFiles[url];
  }
};
var selectors$1 = selectors;

export { selectors$1 as default };
//# sourceMappingURL=selectors.js.map
